import { Link, Typography } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';

export default function LocationLink({ item }: any) {
  const intl = useIntl();
  const { lat, lng, label } = item;
  const text = !label ? intl.formatMessage({ id: 'POST_FORM.LOCALISATION_MARKER_PLACED' }) : label;
  return (
    <Link
      href={
        lat && lng
          ? `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
          : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(label)}`
      }
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      title={intl.formatMessage({ id: 'BUTTONS.OPEN_IN_NEW_TAB' })}
    >
      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
        {text}
      </Typography>
    </Link>
  );
}
